/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import privilegeService from '../../services/privilege'

const initialState = {
  privileges: null,
}

export const getPrivileges = createAsyncThunk(
  'privilege/getPrivileges',
  privilegeService.getPrivileges
)

const privilege = createSlice({
  name: 'privilege',
  initialState,
  reducers: {
    // Handle synchronous actions here
  },
  extraReducers: {
    [getPrivileges.fulfilled]: (state, action) => {
      const { data } = action.payload

      state.privileges = data
    },
    [getPrivileges.rejected]: (state) => {
      state.privileges = null
    },
    [getPrivileges.pending]: (state) => {
      state.privileges = null
    },
  },
})

export default privilege.reducer
